import React, { useEffect } from 'react'

import { useAuthentication } from '../../hooks/useAuthentication'
import { useQuery } from '@apollo/react-hooks'
import { DataTable } from '../table/DataTable'
import { GET_INBOX } from './gql'
import { getInboxColumns } from '../table/columns/inboxColumns'
import { useLocation } from 'react-router-dom'
import { Alert } from '@mui/material'
import Loader from '../Loader'
import { Container } from 'react-bootstrap'
import VoucherExpandedRow from '../table/VoucherExpandedRow'

const InboxVouchers = () => {
  const { authState } = useAuthentication()
  const vouchers = useQuery(GET_INBOX, {
    context: { headers: { authorization: authState.authToken } },
    fetchPolicy: 'network-only', // always fetch fresh data
  })
  const location = useLocation<{ refresh?: boolean }>()
  useEffect(() => {
    if (location.state?.refresh) {
      vouchers.refetch()
    }
  }, [location.state, vouchers])

  if (vouchers.loading) return <Loader />
  if (vouchers.error) return <p>Error: {vouchers.error.message}</p>
  if (!vouchers.data || !vouchers.data.inbox) return <p>No data available</p>

  return (
    <>
      {location.state && (location.state as { message?: string }).message && (
        <>
          <br />
          <Alert variant="outlined" severity="success">
            {(location.state as { message?: string }).message}
          </Alert>
        </>
      )}
      <Container fluid className="px-0">
        <h1>Inbox</h1>
        <DataTable
          data={vouchers.data.inbox ?? []}
          columns={getInboxColumns()}
          renderSubComponent={(row) => (
            <VoucherExpandedRow voucher={row.original} />
          )}
        />
      </Container>
    </>
  )
}

export default InboxVouchers
